<ng-container *transloco="let t">
  <form [formGroup]="inputForm">
    <div class="d-flex justify-content-center flex-column">
      <app-page-heading
        [title]="messageSent ? t('events.details.contacts.message.sent') : t('events.details.contacts.message')"></app-page-heading>
      <div class="form-wrapper d-flex align-items-center flex-column" [style.padding-top]="messageSent ? '30px' : null">
        @if(!messageSent){
        <app-input formControlName="messageSubject" label="{{t('events.details.contacts.message.subject')}}" />
        <div class="pt-20-10">
          <app-textarea id="message" formControlName="message" rows="5" label="events.details.contacts.message" />
        </div>
        <div class="pt-20-10">
          <app-input formControlName="nameAndLastName" label="events.details.contacts.name.last.name" />
        </div>
        <div class="pt-20-10">
          <app-input formControlName="email" label="app.common.email" />
        </div>
        }@else {
        <div class="d-flex justify-content-center flex-column justify-content-center align-items-center">
          <span class="pb-70-30">{{ t("events.details.contacts.reply.soon") }}</span>
          <img src="assets/img/svg/message-sent.svg" alt="Message has been sent"
            class="me-3 message-sent-img img-fluid" />
        </div>
        }
        <div class="pt-48-38 d-flex justify-content-center">
          @if(!messageSent){
          <div class="d-flex">
            <app-rounded-button [label]="t('app.common.cancel')" [btnClass]="'rounded-button--black-outline'"
              (onClick)="onClose()" />
            <div class="pe-20"></div>
            <app-rounded-button [label]="t('events.details.contacts.send.message')" (onClick)="onSendMessage()" />
          </div>
          }@else {
          <app-rounded-button [label]="t('app.common.close')" (onClick)="onClose()" />
          }
        </div>
      </div>
    </div>
  </form>
</ng-container>